export default __webpack_public_path__ + "static/media/1563.a4507fc9.png";